import React from 'react'
import { browserHistory, IndexRoute, Route, Router } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import {
  Application,
  // CybersportPage,
  Footer,
  GamesNewPage,
  IdentifyPage,
  LivePage,
  MainPage,
  SignInPage,
  SignUpPage,
  SportsPage,
} from './components'
import Grid from './components/grid-control'
import { Timetable } from './components/Timetable'

// import IndexSlots from './components/games/slots/index'
// import Betsoft from './components/games/slots/betsoft/index'
// import BetsoftIframe from './components/games/slots/betsoft/Iframe'
// import Betsolutions from './components/games/slots/betsolutions/index'
// import TomHorn from './components/games/slots/tomhorn/index'
// import TomHornIframe from './components/games/slots/tomhorn/Iframe'
// import XpressGames from './components/games/xpress/XpressGames.jsx'
import JacktopGames from './components/games/jacktop/JacktopGames.jsx'

import { isRingo } from 'shared/domainUtils'
// import PinnedXpressGames from './components/games/xpress/PinnedXpressGames.jsx'
import GameTypesPage from './components/pages/GamesTypesPage/GamesTypesPage.jsx'
import FavoriteGames from './components/pages/FavoriteGames/FavoriteGames.jsx'
import RecentGamesPage from './components/pages/RecentGames/RecentGamesPage.jsx'
import AllGames from './components/pages/AllGamesPage/AllGames.jsx'
import PopularGames from './components/pages/PopularGamesPage/PopularGames.jsx'

const RingoBlocker = () => {
  return (
    <h1 style={{ fontSize: 24, padding: 20, maxWidth: 900, margin: '0 auto' }}>
      Регистрация, пополнение счетов и прием ставок недоступны в связи с прекращением действия лицензии №34 на
      осуществление деятельности букмекерской конторы, выданной ТОО "Takebet", согласно приказу №19 от 23.04.2024
      государственного учреждения "Комитет индустрии туризма Министерства туризма и спорта Республики Казахстан".
    </h1>
  )
}

const routes = (store) => {
  const history = syncHistoryWithStore(browserHistory, store)

  if (isRingo) {
    return (
      <Router history={history}>
        <Route path="/" component={Application}>
          <IndexRoute
            components={{
              main: RingoBlocker,
              footer: Footer,
            }}
          />
          <Route
            path="*"
            components={{
              main: RingoBlocker,
              footer: Footer,
            }}
          />
        </Route>
      </Router>
    )
  }

  return (
    <Router history={history}>
      <Route path="/" component={Application}>
        <IndexRoute components={{ main: MainPage, footer: Footer }} />
        <Route path="sign-in" components={{ main: SignInPage }} />
        <Route path="sign-up" components={{ main: SignUpPage }} />
        <Route path="identify" components={{ main: IdentifyPage }} />
        <Route path="sports" components={{ main: SportsPage }} />
        <Route path="sports/:sportId" components={{ main: SportsPage }} />
        <Route path="sports/:sportId/:leagueId" components={{ main: SportsPage }} />
        <Route path="sports/:sportId/:leagueId/:matchId" components={{ main: SportsPage }} />
        <Route path="live" components={{ main: LivePage }}>
          <IndexRoute components={{ center: Grid }} />
          <Route path="timetable" components={{ center: Timetable }} />
        </Route>

        <Route exact path="games" components={{ main: GamesNewPage, footer: Footer }} />
        <Route path="games/types/:categoryId" components={{ main: GameTypesPage, footer: Footer }} />
        <Route path="games/favorites" components={{ main: FavoriteGames, footer: Footer }} />
        <Route path="games/recent" components={{ main: RecentGamesPage, footer: Footer }} />
        <Route path="games/allGames" components={{ main: AllGames, footer: Footer }} />
        <Route path="games/popularGames" components={{ main: PopularGames, footer: Footer }} />
        <Route path="games/jacktop" components={{ main: JacktopGames, footer: Footer }} />
        <Route path="games/:searchTerm" components={{ main: GamesNewPage, footer: Footer }} />

        {/* <Route path="cybersport" components={{ main: CybersportPage }} /> */}
        {/* <Route path="games/slots" components={{ main: IndexSlots, footer: Footer }} /> */}
        {/* <Route path="games/slots/betsoft" components={{ main: Betsoft, footer: Footer }} /> */}
        {/* <Route path="games/slots/betsoft/:id" components={{ main: BetsoftIframe, footer: Footer }} /> */}
        {/* <Route path="games/slots/betsolutions" components={{ main: Betsolutions, footer: Footer }} /> */}
        {/* <Route path="games/slots/tom-horn" components={{ main: TomHorn, footer: Footer }} /> */}
        {/* <Route path="games/slots/tom-horn/:id" components={{ main: TomHornIframe, footer: Footer }} /> */}
        {/* <Route path="games/xpress" components={{ main: XpressGames, footer: Footer }} /> */}
        {/* <Route path="games/xpress/pinned" components={{ main: PinnedXpressGames, footer: Footer }} /> */}
        {/* <Route path="games/jacktop" components={{ main: JacktopGames, footer: Footer }} /> */}
      </Route>
    </Router>
  )
}

export default routes



// WEBPACK FOOTER //
// ./js/sport-betting/routes.js